var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"responses"},[_c('ul',[_c('li',[_vm._v("List completed questionnaires")])]),_c('h3',[_vm._v("backend")]),_c('ul',[_c('li',[_vm._v("when questionnaire is submitted or migrated, add a provider event with type questionnaire that has a copy of the questionnaire content")])])])
}]

export { render, staticRenderFns }